export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 76 76" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="MM100-V1.2版本" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="MM100众筹详情-RV" transform="translate(-734.000000, -5052.000000)">
                    <g id="编组-2" transform="translate(510.000000, 4798.000000)">
                        <g id="Air-Conditioner_icon" transform="translate(224.000000, 254.000000)">
                            <rect id="矩形备份-27" x="0" y="0" width="76" height="76"></rect>
                            <g
                                id="编组-42"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                transform="translate(5.000000, 19.000000)"
                                stroke="#000000"
                                strokeWidth="2"
                            >
                                <path
                                    d="M10.9895084,30.7379673 L11.7678594,32.1078318 C12.1979169,32.8645497 11.9282018,33.8404027 11.1657789,34.2883883 C10.4044179,34.7352944 10.1347028,35.7111476 10.5647603,36.4678654 L11.3420494,37.8377298"
                                    id="Stroke-336"
                                ></path>
                                <path
                                    d="M22.4626988,37.8378378 L21.6843478,36.4668939 C21.2553522,35.7112554 21.5240054,34.7343229 22.2864282,34.2874168 C23.0488512,33.8405107 23.3185663,32.8646576 22.8885088,32.1079398 L22.1101578,30.7380752"
                                    id="Stroke-337"
                                ></path>
                                <path
                                    d="M33.5833481,37.8378378 L32.8049971,36.4668939 C32.3749396,35.7112554 32.6446548,34.7343229 33.4070777,34.2874168 C34.1695005,33.8405107 34.4381537,32.8646576 34.0080962,32.1079398 L33.2308071,30.7380752"
                                    id="Stroke-338"
                                ></path>
                                <path
                                    d="M44.7034666,37.8378378 L43.9261775,36.4668939 C43.49612,35.7112554 43.7647732,34.7343229 44.5271962,34.2874168 C45.289619,33.8405107 45.5593341,32.8646576 45.1292766,32.1079398 L44.3509258,30.7380752"
                                    id="Stroke-339"
                                ></path>
                                <path
                                    d="M55.8240098,37.8378378 L55.045659,36.4668939 C54.6156015,35.7112554 54.8853164,34.7343229 55.6477394,34.2874168 C56.4101624,33.8405107 56.6788155,32.8646576 56.2498198,32.1079398 L55.471469,30.7380752"
                                    id="Stroke-340"
                                ></path>
                                <path
                                    d="M63.030499,25.9086823 L3.18561099,25.9086823 C1.42609185,25.9086823 0,24.4589359 0,22.6702318 L0,3.23845034 C0,1.44866678 1.42609185,0 3.18561099,0 L63.030499,0 C64.7900182,0 66.2161101,1.44866678 66.2161101,3.23845034 L66.2161101,22.6702318 C66.2161101,24.4589359 64.7900182,25.9086823 63.030499,25.9086823 Z"
                                    id="Stroke-341"
                                ></path>
                                <line x1="0.000106187035" y1="18.2226521" x2="66.2162162" y2="18.2226521" id="Stroke-343"></line>
                                <line x1="3.53677151" y1="12.3545801" x2="9.69825863" y2="12.3545801" id="Stroke-344"></line>
                                <line x1="13.9428884" y1="12.3545801" x2="17.1943353" y2="12.3545801" id="Stroke-345"></line>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
